export enum validationTypes {
  Pattern = 0,
  MinLength = 1,
  MaxLength = 2,
  Email = 3,
}
